import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AccessControlService } from '../services/access-control.service';
import { ToastrService } from 'ngx-toastr';
import { Preference } from '../model/preference.modals';
import { Router, NavigationEnd } from '@angular/router';
import { toInt } from 'ngx-bootstrap/chronos/utils/type-checks';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.css']
})
export class PreferencesComponent implements OnInit {
  preference: Preference;
  showCog = true;
  @ViewChild('boxedLayout') boxedLayoutBtn:ElementRef
  @ViewChild('fixednavbar1') fixedNavbar1Btn:ElementRef
  @ViewChild('fixednavbar2') fixedNavbar2Btn:ElementRef
  @ViewChild('fixedfooter') fixedFooterBtn:ElementRef
  @ViewChild('flatdesign') flatDesignBtn:ElementRef
  @ViewChild('collapsemenu') collapseMenuBtn:ElementRef
  @ViewChild('fixedsidebar') fixedSidebarBtn:ElementRef
  constructor(private accessControlService: AccessControlService, private alertService: ToastrService, private router: Router) {
    this.preference = new Preference()
  }

  ngOnInit() {
    if ((localStorage.boxedlayout && localStorage.boxedlayout == "on")) {
      this.setOn(this.boxedLayoutBtn)
      this.onBoxedLayout(null);
    }
    if ((localStorage.collapse_menu && localStorage.collapse_menu == "on")) {
      this.setOn(this.collapseMenuBtn)
      this.onCollapseMenu(null);
    }
    if ((localStorage.fixedfooter && localStorage.fixedfooter == "on")) {
      this.setOn(this.fixedFooterBtn)
      this.onFixedFooter(null);
    }
    if ((localStorage.fixednavbar1 && localStorage.fixednavbar1 == "on")) {
      this.setOn(this.fixedNavbar1Btn)
      this.onFixednavbar(null);
    }
    if ((localStorage.fixednavbar2 && localStorage.fixednavbar2 == "on")) {
      this.setOn(this.fixedNavbar2Btn)
      this.onFixedTopnavbar(null);
    }
    if ((localStorage.fixedsidebar && localStorage.fixedsidebar == "on")) {
      this.setOn(this.fixedSidebarBtn)
      this.onFixedSidebar(null);
    }
    if ((localStorage.fixedfooter && localStorage.fixedfooter == "on")) {
      this.setOn(this.fixedFooterBtn)
      this.onFixedFooter(null);
    }

    if ((localStorage.flatedesign && localStorage.flatedesign == "on")) {
      this.setOn(this.flatDesignBtn)
      this.onFlateDesign(null);
    }
    else{
      this.addClass(this.getElementsByTagName('body'),'md-skin')

    }
    if (localStorage.skin_type) {
      this.onSkinChange(localStorage.skin_type)
    }
    else{
      this.onSkinChange('skin-4')
    }

  }

  /**
   * To toggle the side menu bar
   * @memberof PreferencesComponent
   */
  togglePreferences() {
    const themeConfigBox=this.getElementsByClassName('theme-config-box')
    for(let i=0;i<themeConfigBox.length;i++)
      themeConfigBox[i].classList.toggle('show')
  }
  /**
   * To change the skin type
   * @param {string} skin name of the skin type
   * @memberof PreferencesComponent
   */
  onSkinChange(skin: string) {
    const avgTimings=this.getElementById('avgTimings')
    const body=this.getElementsByTagName('body')
    this.removeClass(avgTimings,'skin-1timing',false)
    this.removeClass(avgTimings,'skin-3timing',false)
    this.addClass(avgTimings,'skin-0avgTimings',false)
    this.removeClass(body,'skin-0')
    this.removeClass(body,'skin-1')
    this.removeClass(body,'skin-2')
    this.removeClass(body,'skin-3')
    this.removeClass(body,'skin-4')
    this.addClass(body,skin)
    this.removeClass(avgTimings,'skin-0avgTimings',false)
    this.removeClass(avgTimings,'skin-3timing',false)
    this.removeClass(avgTimings,'skin-1timing',false)
    this.removeClass(avgTimings,'skin-2timing',false)
    this.removeClass(avgTimings,'skin-4timing',false)
    this.addClass(avgTimings,skin + 'timing',false)
    localStorage.setItem('skin_type', skin);
    this.preference.skin_type = skin;
    if (event != null)
      this.saveUserPreferences();

  }
  /**
   * To set the fixed top navbar
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onFixednavbar(event: any) {
    const body=this.getElementsByTagName('body')
    if (this.fixedNavbar1Btn.nativeElement.checked) {
      const navbarStaticTop=this.getElementsByClassName('navbar-static-top')
      this.addClass(navbarStaticTop,'navbar-fixed-top')
      this.removeClass(navbarStaticTop,'navbar-static-top')
      this.removeClass(body,'boxed-layout')
      this.addClass(body,'fixed-nav')
      this.setOff(this.boxedLayoutBtn)
      localStorage.setItem("boxedlayout", 'off');
      localStorage.setItem("fixednavbar1", 'on');
    } else {
      const navbarFixedTop=this.getElementsByClassName('navbar-fixed-top')
      this.addClass(navbarFixedTop,'navbar-static-top')
      this.removeClass(navbarFixedTop,'navbar-fixed-top')
      this.removeClass(body,'fixed-nav')
      this.removeClass(body,'fixed-nav-basic')
      this.setOff(this.fixedNavbar2Btn)
      localStorage.setItem("fixednavbar1", 'off');
      localStorage.setItem("fixednavbar2", 'off');
    }
    if (event != null)
      this.saveUserPreferences();
  }
  /**
   * To set the primary type fixed top navbar
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onFixedTopnavbar(event: any) {
    const body=this.getElementsByTagName('body')
    if (this.fixedNavbar2Btn.nativeElement.checked) {
      const navbarStaticTop=this.getElementsByClassName('navbar-static-top')
      this.addClass(navbarStaticTop,'navbar-fixed-top')
      this.removeClass(navbarStaticTop,'navbar-static-top')
      this.removeClass(body,'boxed-layout')
      this.addClass(body,'fixed-nav')
      this.addClass(body,'fixed-nav-basic')
      this.setOff(this.boxedLayoutBtn)
      localStorage.setItem("boxedlayout", 'off');
      localStorage.setItem("fixednavbar2", 'on');
    } else {
      const navbarFixedTop=this.getElementsByClassName('navbar-fixed-top')
      this.addClass(navbarFixedTop,'navbar-static-top')
      this.removeClass(navbarFixedTop,'navbar-fixed-top')
      this.removeClass(body,'fixed-nav')
      this.removeClass(body,'fixed-nav-basic')
      this.setOff(this.fixedNavbar1Btn)
      localStorage.setItem("fixednavbar2", 'off');
      localStorage.setItem("fixednavbar1", 'off');
    }
    if (event != null)
      this.saveUserPreferences();
  }
  /**
   * To set the boxed layout
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onBoxedLayout(event: any) {
    const body = this.getElementsByTagName('body')
    if (this.boxedLayoutBtn.nativeElement.checked) {
      const navbarFixedTop=this.getElementsByClassName('navbar-fixed-top')
      const footer=this.getElementsByClassName('footer')
      this.addClass(body,'boxed-layout')
      this.setOff(this.fixedNavbar1Btn)
      this.setOff(this.fixedNavbar2Btn)
      this.addClass(navbarFixedTop,'navbar-static-top')
      this.removeClass(navbarFixedTop,'navbar-fixed-top')
      this.removeClass(body,'fixed-nav')
      this.removeClass(body,'fixed-nav-basic')
      this.removeClass(footer,'fixed')
      this.setOff(this.fixedFooterBtn)
      localStorage.setItem("fixednavbar1", 'off');
      localStorage.setItem("fixednavbar2", 'off');
      localStorage.setItem("fixedfooter", 'off');
      localStorage.setItem("boxedlayout", 'on');
    } else {
      this.removeClass(body,'boxed-layout')
      localStorage.setItem("boxedlayout", 'off');
    }
    if (event != null) {
      this.saveUserPreferences()
    }
  }
  /**
   * To set the fixed footer
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onFixedFooter(event: any) {
    const footer=this.getElementsByClassName('footer')
    if (this.fixedFooterBtn.nativeElement.checked) {
      const body = this.getElementsByTagName('body')
      this.setOn(this.fixedFooterBtn)
      this.setOff(this.boxedLayoutBtn)
      this.removeClass(body,'boxed-layout')
      this.addClass(footer,'fixed')
      localStorage.setItem("boxedlayout", 'off');
      localStorage.setItem("fixedfooter", 'on');
    } else {
      this.removeClass(footer,'fixed')
      this.setOff(this.fixedFooterBtn)
      localStorage.setItem("fixedfooter", 'off');
    }
    if (event != null)
      this.saveUserPreferences();

  }
  /**
   * To set the fixed side navbar
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onFixedSidebar(event: any) {
    const body=this.getElementsByTagName('body')
    const sidebarCollapse=this.getElementsByClassName('sidebar-collapse')[0]
    if (this.fixedSidebarBtn.nativeElement.checked) {
      // jquery scrollbar
      this.addClass(body,'fixed-sidebar');
       (<any>document.getElementsByClassName('.sidebar-collapse')[0]).slimScroll({
        height: '100%',
        railOpacity: 0.9
      });
      this.SmoothlyMenu()
      this.setOff(this.collapseMenuBtn)
      localStorage.setItem("collapsemenu", 'off');
      this.removeClass(body,'mini-navbar')
      localStorage.setItem("fixedsidebar", 'on');
    } else {
      // jquery scrollbar
      (<any>document.getElementsByClassName('.sidebar-collapse')[0]).slimscroll({ destroy: true });
      (<any>document.getElementsByClassName('.sidebar-collapse')[0]).removeAttribute("style");
      sidebarCollapse.setAttribute('style','')
      this.removeClass(body,'fixed-sidebar')
      localStorage.setItem("fixedsidebar", 'off');
    }
    if (event != null)
      this.saveUserPreferences();
  }
  /**
   * To set the menu stye
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onCollapseMenu(event: any) {
      const body=this.getElementsByTagName('body')
      if (this.collapseMenuBtn.nativeElement.checked) {
        this.addClass(body,'mini-navbar')
        this.SmoothlyMenu();
        localStorage.setItem("collapse_menu", 'on');
      } else {
        this.removeClass(body,'mini-navbar')
        this.SmoothlyMenu();
        localStorage.setItem("collapse_menu", 'off');
      }
      if (event != null)
        this.saveUserPreferences();
    }

  SmoothlyMenu() {
    const body=this.getElementsByTagName('body')[0]
    const sideMenu=this.getElementById('side-menu')
    if(body.classList.contains('mini-navbar')||body.classList.contains('body-small')){
      sideMenu.style.display='none'
      sideMenu.style.opacity  = '0';
      setTimeout(function(){
        const sideMenu=document.getElementById('side-menu')
        const time=500
        let calculatedOpacity=0
        sideMenu.style.opacity  = '0';
        sideMenu.style.display='block'
        let last= +new Date();
        let tick = function() {
          calculatedOpacity = +sideMenu.style.opacity + ( new Date() as any - last) / time;
          sideMenu.style.opacity=calculatedOpacity.toString()
          last = +new Date();
          if (+sideMenu.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
          }
        };
        tick();
      },200)
    }
    else if(body.classList.contains('fixed-sidebar')){
      sideMenu.style.display='none';
      setTimeout(function () {
          const sideMenu=document.getElementById('side-menu')
          sideMenu.style.display='none'
          sideMenu.style.opacity  = '0';
          const time=500
          let calculatedOpacity=0
          sideMenu.style.opacity = '0';
          sideMenu.style.display='block'
          let last= +new Date();
          let tick = function() {
            calculatedOpacity= +sideMenu.style.opacity + ( new Date() as any - last) / time;
            sideMenu.style.opacity=calculatedOpacity.toString()
            last = +new Date();
            if (+sideMenu.style.opacity < 1) {
              (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
          };
          tick();
        }, 200)
    }
    else{
      const sideMenu=document.getElementById('side-menu')
      sideMenu.style.display='none'
      sideMenu.style.opacity  = '0';
      setTimeout(function(){
        const sideMenu=document.getElementById('side-menu')
        const time=500
        sideMenu.style.opacity  = '0';
        let calculatedOpacity=0
        sideMenu.style.display='block'
        let last= +new Date();
        let tick = function() {
          calculatedOpacity = +sideMenu.style.opacity + ( new Date() as any - last) / time;
          sideMenu.style.opacity=calculatedOpacity.toString()
          last = +new Date();
          if (+sideMenu.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
          }
        };
        tick();
      },200)
      // sideMenu.removeAttribute('style')
    }

  }
  /**
   * To set the flate design
   * @param {*} event
   * @memberof PreferencesComponent
   */
  onFlateDesign(event: any) {
    const body=this.getElementsByTagName('body')
    if (this.flatDesignBtn.nativeElement.checked) {
      this.removeClass(body,'md-skin')
      this.setOn(this.flatDesignBtn)
      localStorage.setItem('flatedesign', 'on')
    } else {
      this.addClass(body,'md-skin')
      this.setOff(this.flatDesignBtn)
      localStorage.setItem('flatedesign', 'off')
    }
    let skin_type=localStorage.getItem('skin_type')
    if(!skin_type&&skin_type!=null){
      skin_type='skin-4'
    }
    this.onSkinChange(skin_type);
    if (event != null)
      this.saveUserPreferences();
  }

  saveUserPreferences() {
    this.preference.boxedlayout = localStorage.boxedlayout,
      this.preference.collapse_menu = localStorage.collapse_menu,
      this.preference.fixedfooter = localStorage.fixedfooter,
      this.preference.fixednavbar1 = localStorage.fixednavbar1,
      this.preference.fixednavbar2 = localStorage.fixednavbar2,
      this.preference.fixedsidebar = localStorage.fixedsidebar,
      this.preference.skin_type = localStorage.skin_type,
      this.preference.flatedesign = localStorage.flatedesign
    this.accessControlService.savePreferences({ userId: localStorage.getItem('user_id'), preferences: this.preference }).subscribe((res) => {
      if (res['success'])
        console.log();// this.alertService.success('Preferences saved successfully.')
      else
        this.alertService.error('oops something went wrong.')
    },
      error => {
        alert('Error')
      })
  }

  /**
   * To add a class
   * @param {*} elementRef
   * @param {string} className
   * @param {boolean} [isTypeCollection=true]
   * @memberof PreferencesComponent
   */
  addClass(elementRef,className:string,isTypeCollection=true){
    if(elementRef)
    switch(isTypeCollection){
      case true:
        for(let i=0;i<elementRef.length;i++){
          elementRef[i].classList.add(className)
        }
      break;
      case false:
        elementRef.classList.add(className)
    }
  }
  /**
   * To remove a class
   * @param {*} elementRef
   * @param {string} className
   * @param {boolean} [isTypeCollection=true]
   * @memberof PreferencesComponent
   */
  removeClass(elementRef:any,className:string,isTypeCollection=true){
    if(elementRef)
    switch(isTypeCollection){
      case true:
        for(let i=0;i<elementRef.length;i++){
          elementRef[i].classList.remove(className)
        }
      break;
      case false:
        elementRef.classList.remove(className)
    }
  }
  /**
   * to set the switch on
   * @param {*} elementRef
   * @memberof PreferencesComponent
   */
  setOn(elementRef){
    elementRef.nativeElement.checked=true
  }
  /**
   * To set a swith off
   * @param {*} elementRef
   * @memberof PreferencesComponent
   */
  setOff(elementRef){
    elementRef.nativeElement.checked=false
  }
  /**
   * To get an element by id
   * @param {*} id
   * @returns
   * @memberof PreferencesComponent
   */
  getElementById(id){
    return document.getElementById(id)
  }
  /**
   * To get an element by class
   * @param {*} className
   * @returns
   * @memberof PreferencesComponent
   */
  getElementsByClassName(className){
    return document.getElementsByClassName(className)
  }
  /**
   * To get an element by tag name
   * @param {*} tagName
   * @returns
   * @memberof PreferencesComponent
   */
  getElementsByTagName(tagName){
    return document.getElementsByTagName(tagName)
  }
}
